import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { CategoryLink } from '../form-elements/Link';
import { categoryUrlSelector } from '../../../modules/selectors/url';

export function MobileCategory({ category, activeCategory, setActiveCategory, parentCategory, setIsNavSidebarVisible }) {
    const categoryUrl = useSelector(categoryUrlSelector);
    const isCurrentCategory = category.url === categoryUrl;
    const sortedSubCategories = _.sortBy(category?.subCategories || [], ['title']);

    return (
        <>
            {category?.subCategories && category.subCategories?.length > 0 ?
                <>
                    {((!parentCategory && category?.masterCategory == null && !activeCategory) || String(parentCategory?._id) === String(activeCategory)) &&
                        <li
                            className={classnames('mobile-menu-category', {
                                'mobile-menu-category-active': isCurrentCategory,
                            })}
                            onClick={() => setActiveCategory(category._id)}
                        >
                            <div>{category.title}</div><span uk-icon="icon: chevron-right"></span>
                        </li>
                    }
                    {(activeCategory && String(category?._id) === String(activeCategory)) &&
                        <>
                            <li className='mobile-menu-category-all-back' onClick={() => { setActiveCategory(null); }}>
                                <span uk-icon="icon: menu"></span><div>Zeige alle Kategorien</div>
                            </li>
                            <li className='mobile-menu-category-current' onClick={() => { setIsNavSidebarVisible(false); }}>
                                <CategoryLink category={category} className='mobile-menu-category-current-link'>
                                    {category.title}
                                </CategoryLink>
                            </li>
                            <li className='mobile-menu-category-back' onClick={() => { setActiveCategory(category?.masterCategory ? category?.masterCategory : null); }}>
                                <span uk-icon="icon: chevron-left"></span><div>Zurück</div>
                            </li>
                        </>
                    }
                    {sortedSubCategories.map(subCategory => {
                        return (
                            <MobileCategory
                                key={subCategory._id}
                                category={subCategory}
                                activeCategory={activeCategory}
                                setActiveCategory={setActiveCategory}
                                parentCategory={category}
                                setIsNavSidebarVisible={setIsNavSidebarVisible}
                            />
                        );
                    })}
                </>
                :
                <>
                    {((!parentCategory && category?.masterCategory == null && !activeCategory) || String(parentCategory?._id) === String(activeCategory)) &&
                        <li className='mobile-menu-category' onClick={() => { setIsNavSidebarVisible(false); }}>
                            <CategoryLink
                                category={category}
                                className={classnames('mobile-menu-category-link', {
                                    'mobile-menu-category-link-active': isCurrentCategory,
                                })}
                            >
                                {category.title}
                            </CategoryLink>
                        </li>
                    }
                </>
            }
        </>
    );
}
